export default "__VITE_ASSET__odekQZon__"